const BLOCK = /<attached-skills>\n[\s\S]*?\n<\/attached-skills>/g;

export function buildAttachedSkillsBlock(
  skills: readonly { name: string }[]
): string {
  const names = skills.map((skill) => `- ${skill.name}`).join("\n");
  return `<attached-skills>\nThe user explicitly activated these skills for this message:\n${names}\n</attached-skills>`;
}

export function prependAttachedSkills(
  text: string,
  skills: readonly { name: string }[]
): string {
  if (skills.length === 0) return text;
  const block = buildAttachedSkillsBlock(skills);
  return block + (text ? `\n\n${text}` : "");
}

export function attachedSkillNames(text: string): string[] {
  return [
    ...new Set(
      [...text.matchAll(BLOCK)].flatMap((match) =>
        match[0]
          .split("\n")
          .filter((line) => line.startsWith("- "))
          .map((line) => line.slice(2).trim())
          .filter(Boolean)
      )
    ),
  ];
}

export function stripAttachedSkillsBlock(text: string): string {
  return text.replace(BLOCK, "").trim();
}
